import isAccountApplicableProduct from './isAccountApplicableProduct';

/**
 * Resolve account instance by its ID from the product instance.
 *
 * @param {object} product
 * @param {number} accountId
 * @return {object|null}
 */
export default (product, accountId) => {
    if (isAccountApplicableProduct(product) || !accountId) {
        return null;
    }
    return typeof accountId !== 'object' && product?.accounts && product?.accounts?.length
        ? product?.accounts?.find(item => item?.account_id === accountId)
        : null;
}
